$(document).ready(function(e){
  $(window).on('scroll load',function(){
    var sticky = $('body'),
        scroll = $(window).scrollTop();
    if (scroll > 2) sticky.addClass('h_sticky');
    else sticky.removeClass('h_sticky');
  });
  $(".mega_list,.megamenu_div,.mega_listlink").hover(
    function () {
      $('body').addClass("box-hover");
    },
    function () {
      $('body').removeClass("box-hover");
    }
  );
  $(document).on('click','.h_search_btn,.searchclose',function(e){
    e.preventDefault();
    $('body').toggleClass('searchopen');
    $('body').removeClass('CartOpen');
    if($('body').hasClass('searchopen')){
      $('.search_h_input').focus();
    }
  });
  if($('.main_slidercls').length>0){
    $(window).on('load scroll',function(){
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      $('.shopify-section').each(function(e){
        var elemTop = $(this).offset().top;
        if(elemTop < docViewBottom){
          $(this).addClass('active_section');
        }else{
          $(this).removeClass('active_section');
        }
      });            
    });
  }
  if($('.main_slidercls').length>0){
    $('.main_slidercls').each(function(e){
      var mainslide = $(this);
      var nextbtn = $(this).find('.swiper-button-next');
      var prevbtn = $(this).find('.swiper-button-prev');
      var pagination = $(this).find('.swiper-pagination');
      var loopdata = mainslide.data('loop');
      var autoplyatime = mainslide.data('timimg');
      var autoplayenable = mainslide.data('autoplay');      
      if(autoplayenable==true){        
        var swiper = new Swiper(mainslide, {
          slidesPerView: "auto",
          spaceBetween: 0,
          //centeredSlides: true,
          speed: 1000,
          loop: loopdata,
          parallax: !0,
          navigation: {
            nextEl: nextbtn,
            prevEl: prevbtn,
          },
          autoplay: {
            delay: autoplyatime,
          },  
          pagination: {
            el: pagination,
            clickable: true,
          },          	
          //         mousewheel: {
          //           enable: true,
          //           invert: false,
          //           releaseOnEdges: true,
          //         },
        });  
      }else{         
		var swiper = new Swiper(mainslide, {
          slidesPerView: "auto",
          spaceBetween: 0,
          speed: 1000,
          loop: loopdata,
          parallax: !0,
          navigation: {
            nextEl: nextbtn,
            prevEl: prevbtn,
          },          
          pagination: {
            el: pagination,
            clickable: true,
          },          
        });  
      }
//       swiper.on('slideChange', function () {
//         //var activeslider = mainslide.find('.main_slide.swiper-slide-active').data('class');
//         //console.log(activeslider);
//         //var currentindex = mainslide.data('id')+swiper.realIndex;
//         //$('body').attr('data-classindex',currentindex);

//         var currntcls = $(mainslide).closest('.shopify-section.active_section').find('.main_slidercls .swiper-slide-active').data('class');

//         if(currntcls != undefined){
//           console.log(currntcls);
//           var currentindex = $(mainslide).closest('.shopify-section.active_section').find('.main_slidercls').attr('data-id')+currntcls;         
//           $('body').attr('data-classindex',currentindex);
//         }      
//       });      
      swiper.on('slideChangeTransitionStart', function () {
        var currntcls = $(mainslide).closest('.shopify-section.active_section').find('.main_slidercls .swiper-slide-active').data('class');
		if(currntcls != undefined){
          var currentindex = $(mainslide).closest('.shopify-section.active_section').find('.main_slidercls').attr('data-id')+currntcls;         
          $('body').attr('data-classindex',currentindex);
        }      
      });
    });    
  }
  $('.pro_Slider').each(function(e){
    var proslider = $(this);
    var swiper = new Swiper(proslider, {
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 1000,
      loop: true,      
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
  $('.pdp_acc_title').on('click',function(e){
  	$(this).next('.pdp_acc_data').slideToggle().closest('.pdp_acc_wrap').siblings().find('.pdp_acc_data').slideUp();
    $(this).toggleClass('active').closest('.pdp_acc_wrap').siblings().find('.pdp_acc_title').removeClass('active');
  });
  $('.pdpvariant_label').on('click',function(e){
  	$(this).next('.variant_droplist').slideToggle().closest('.clsproform').siblings().find('.variant_droplist').slideUp();
    $(this).toggleClass('active');
  });
  $('.cartgridright .quantity__button').on('click',function(e){
  	$(this).addClass('active').siblings().removeClass('active');
    $('.cart__update-button').trigger('click');
  });
  $('.n_nogift').on('click',function(e){
  	e.preventDefault();
    //$(this).toggleClass('active');
    //$('.giftboxbtm').slideToggle();
    var giftid = $(this).closest('.giftwrapbox').find('.giftproduct').data('id');
    $.ajax({
      type:'POST',
      url:'/cart/add.js',
      dataType:'json',
      data:{id:giftid,quantity:1},
      success:function(response) {
        location.reload();        
      },
      error: function(XMLHttpRequest, textStatus){
        console.log(XMLHttpRequest,'error');
      }
    });
  });
  $('.n_withgift,.giftproductremove').on('click',function(e){
  	e.preventDefault();
    var giftid = $(this).closest('.giftwrapbox').find('.giftproduct').data('id');
    $.ajax({
      type:'POST',
      url:'/cart/change.js',
      dataType:'json',
      data:{id:giftid,quantity:0},
      success:function(response) {
        location.reload();        
      },
      error: function(XMLHttpRequest, textStatus){
        console.log(XMLHttpRequest,'error');
      }
    });
  });
  $(document).on('click','.giftproductadd',function(e){
    e.preventDefault();
    var giftid = $(this).data('id');
    $.ajax({
      type:'POST',
      url:'/cart/add.js',
      dataType:'json',
      data:{id:giftid,quantity:1},
      success:function(response) {
        location.reload();        
      },
      error: function(XMLHttpRequest, textStatus){
       console.log(XMLHttpRequest,'error');
      }
    });
  });
//   var shiprate = Shopify.currency.rate;
//   var shipprice = $('.free_ship_text').data('shipprice')*shiprate;
//   var cartprice = $('.free_ship_text').data('totalprice')*shiprate;
//   if(cartprice>=shipprice){
//   	$('.free_ship_text').show();	
//   }else{
//   	$('.free_ship_text').hide();
//   }
  $('.faq_title').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.faq_wrap').toggleClass('active').siblings().removeClass('active');
    $(this).next('.faq_answers').slideToggle().closest('.faq_wrap').siblings().find('.faq_answers').slideUp();    
  });
  $('.faq_back').on('click',function(e){
  	e.preventDefault();
    $('.faq_page').removeClass('hidefaqtitles');
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
  $('.faq_leftside li a').on('click',function(e){
  	e.preventDefault();    
    $(this).closest('li').addClass('active').siblings().removeClass('active');
    var datacat = $(this).data('title');
    $('.faq_rightcls[data-cat="'+datacat+'"]').addClass('active').siblings().removeClass('active');
    $('.faq_rightcls[data-cat="'+datacat+'"]').addClass('selected').siblings().removeClass('selected');
    $('.faq_page').addClass('hidefaqtitles');
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
  $(document).on('click','.h_cart_btn,.card_close',function(e){
  	e.preventDefault();
    $('body').toggleClass('CartOpen');
  }); 
  $('body').on('click',function(e){       
    var cartbox = $(".cart-side-panel,.h_cart_btn");    
    if (!cartbox.is(e.target) && cartbox.has(e.target).length === 0){
      $('body').removeClass('CartOpen');
    }
  });
  $('body').on('click',function(e){       
    var menubox = $(".h_menu_btn,.mob_header_drawer,.desk_currency,.currency_cls");    
    if (!menubox.is(e.target) && menubox.has(e.target).length === 0){
      $('body').removeClass('menuopen');
      $('.currency_cls').slideUp();
    }
  });
  $('.pshows').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.password_field').find('.phide').show();
    $(this).hide();
    $(this).closest('.password_field').find('input').attr('type','text');
  });
  $('.phide').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.password_field').find('.pshows').show();
    $(this).hide();
    $(this).closest('.password_field').find('input').attr('type','password');
  });
  $(document).on('click','.recoverbtncls',function(e){
  	e.preventDefault();
    $('.forgot_password').show();
    $('.logreg_form').hide();
  });
  $(document).on('click','.loginbtncls',function(e){
  	e.preventDefault();
    $('.forgot_password').hide();
    $('.logreg_form').show();
  });
  $('.order_top').on('click',function(e){
  	$(this).next('.order_btm').slideToggle();
    $(this).toggleClass('active');
  }); 
  $('.mob_m_arw').on('click',function(e){
  	e.preventDefault();
    $(this).closest('.mob_linkouter').next('.mob_subnav').slideToggle();
    $(this).closest('.mob_linkouter').toggleClass('active');
  });
  $(document).on('click','.h_drawerclose,.h_menu_btn',function(e){
  	$('body').toggleClass('menuopen');
  });  
  $('.acccount_link').on('click',function(e){
  	e.preventDefault();
    $('.right_Acc_col').show();
    $('.left_acc_Col,.acc_title').hide();
  });
  let cartsession = sessionStorage.getItem('cart_popup');
  if(cartsession=='true'){
  	$('.pdp_template .s_popuptext,.pdp_template .s_popupclose').hide();
  }else{
  	$('.pdp_template .s_popuptext,.pdp_template .s_popupclose').show();
  }
  let checkoutsession = sessionStorage.getItem('checkout_popup');
  if(checkoutsession=='true'){
  	$('.cart_template .s_popuptext,.cart_template .s_popupclose').hide();
  }else{
  	$('.cart_template .s_popuptext,.cart_template .s_popupclose').show();
  }
  $('.s_popupclose').on('click',function(e){
  	e.preventDefault();
    $(this).hide();
    $(this).next('.s_popuptext').hide();
    sessionStorage.setItem('cart_popup', 'true');
    sessionStorage.setItem('checkout_popup', 'true');
    //$(this).closest('.sticky_rainbtn').removeClass('fix_rainbtn');
    //$('body').addClass('remove_pc_stick');
  });
  if($('.sticky_rainbtn').length>0){
    $(window).scroll(function(){
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();
      var elemTop = $('.sticky_reachcls').offset().top;
      if(elemTop < docViewBottom){
        //$('.sticky_rainbtn').removeClass('fix_rainbtn');
      }else{
        //$('.sticky_rainbtn').addClass('fix_rainbtn');
      }
    });
  }
  let freeshipdata = sessionStorage.getItem('fresship');
  if(freeshipdata=='true'){
  	$('.free_shipbar').removeClass('active');
  }else{
  	$('.free_shipbar').addClass('active');
  }
  $(document).on('click','.free_shipclose',function(){
    $('.free_shipbar').removeClass('active');
    sessionStorage.setItem('fresship', 'true');
  });
  $('.currency_btn').on('click',function(e){
  	e.preventDefault();
    $(this).next('.currency_cls').slideToggle();
  });
  $(document).keydown(function(e){
    if(e.keyCode == 27) {
      $('body').toggleClass('CartOpen');
    }
  });  
  $('.mob_currency').on('click',function(e){
  	e.preventDefault();
    $('.mfirst_drawer').hide();
    $('.mob_Sec_drawer').show();
  });
  $('.curr_back,.h_drawerclose').on('click',function(e){
  	e.preventDefault();
    $('.mfirst_drawer').show();
    $('.mob_Sec_drawer').hide();
  });
  $('.giftlearnmore,.close_boxgift').on('click',function(e){
  	e.preventDefault();
    $('.gift_box_popup').toggleClass('active_giftbox');
  });
  $('body').on('click',function(e){       
    var giftbox_var = $(".gift_box_popup,.giftlearnmore");    
    if (!giftbox_var.is(e.target) && giftbox_var.has(e.target).length === 0){
      $('.gift_box_popup').removeClass('active_giftbox');
    }
  });
  $('.size_label_popup').on('mouseenter, click' ,function(e){
  	e.preventDefault();
    var this_idvar = $(this).data('id');
    $('.size_popup[data-id="'+this_idvar+'"]').closest('.n_size_wrap').addClass('active').siblings().addClass('active');
  });  
  $('.size_popup_close').on('click',function(e){
  	e.preventDefault();
    var this_idvar = $(this).data('id');
    $('.size_popup[data-id="'+this_idvar+'"]').closest('.n_size_wrap').removeClass('active').siblings().removeClass('active');
  });  
  $('body').on('click',function(e){       
    var giftbox_var = $(".size_label_popup,.size_popup");    
    if (!giftbox_var.is(e.target) && giftbox_var.has(e.target).length === 0){
      $('.n_size_wrap').removeClass('active');
    }
  });
});
wow = new WOW(
  {
    animateClass: 'animated',
    offset: 100
  }
);
wow.init();
$(document).ready(function() {
  $(window).on("load scroll", function() {
    var parallaxElement = $(".mod_imgcaptions"),
        scaleElement = $(".mod_imgcaptions"),
        parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function() {
      for (var i = 0; i < parallaxQuantity; i++) {
        var currentElement = parallaxElement.eq(i),
            currentscaleElement = scaleElement.eq(i),
            windowTop = $(window).scrollTop(),
            elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop - elementTop + viewPortHeight;
        currentElement.css({
          transform: "translate3d(0," + scrolled * -0.04 + "px, 0)"
        });        
      }
    });
  });
});
// $(window).on('load',function(e){
//   $('.vimeo_videocls').each(function(e){
//     var vimeo_id = $(this).attr('id');
//     console.log(vimeo_id);
//     setTimeout(function(){
//       $('#'+vimeo_id).attr("src", $('#'+vimeo_id).attr("src").replace('autoplay=1', "autoplay=1"));
//     }, 2000);
//   });
// });
